// extracted by mini-css-extract-plugin
export default {"parkwebDisclaimerText":"FooterParkWeb_parkwebDisclaimerText__QeUks"};